import _import_ from "@assets/js/pub_import.js";
const BASE_URL = "masterStup";
export default [
  {
    path: "/user",
    component: _import_(BASE_URL + "/userHome.vue"),
  },
  {
    path: "/role",
    component: _import_(BASE_URL + "/roleGe.vue")
  },
  {
    path: "/all_rule",
    component: _import_(BASE_URL + "/all_rule.vue")
  },
];
